module.exports = __webpack_public_path__ + "img/page14-min.7374d1c8.jpg";